import { UdyogLogo } from "@/components/UdyogLogo";

/**
 * Udyog mark on the shared screen — shown ONLY in focus mode (once the
 * controls have faded away) so it never duplicates the header logo. The host's
 * uploaded brand logo deliberately does NOT appear here; it belongs on the
 * contact cards.
 */
export function ShareWatermark({ chromeVisible }) {
  return (
    <div
      className={`absolute top-4 left-4 pointer-events-none drop-shadow-[0_2px_8px_rgba(0,0,0,0.9)] transition-opacity duration-500 ${
        chromeVisible ? "opacity-0" : "opacity-90"
      }`}
      data-testid="share-watermark"
    >
      <UdyogLogo size={22} />
    </div>
  );
}
